import { useRef, useEffect } from 'react';
export function useDocumentEvent(eventName, fn, options) {
  var handler = useRef(fn);
  useEffect(function () {
    handler.current = fn;
  }, [fn]);
  useEffect(function () {
    var trigger = function trigger(e) {
      return handler.current(e);
    };

    document.addEventListener(eventName, trigger, options);
    return function () {
      return document.removeEventListener(eventName, trigger, options);
    };
  }, [eventName, options]);
}